import React from 'react'
import Branding from './Branding'
import PageSection from './PageSection'
import Compliance from './Compliance'
import Booking from './Booking'
import Footer from './Footer'
import Clients from './Clients'

import { FaUserCircle } from "react-icons/fa";
import { SiAdguard } from "react-icons/si";
import { BsFillBookmarkStarFill } from "react-icons/bs";
import { FaPencilAlt,FaEye,FaCalendarAlt,FaPaperPlane,FaComments   } from "react-icons/fa";
import { TiSocialInstagram } from "react-icons/ti";

import fs from '../../SocialImage/fs.jpeg';
import cl from '../../SocialImage/calendar.jpeg';
import cm from '../../SocialImage/comments.jpeg';

import ps from '../../SocialImage/post.png';

import mn from '../../SocialImage/monitoring.jpeg';

import com from '../../SocialImage/compose.jpeg';
import { useNavigate } from 'react-router-dom'




function Social() {
const navigate = useNavigate();

  const composeEngagingContentData = [
    {
      icon: <FaPencilAlt />,
      image: com,
      iconTitle: 'Compose Engaging Content',
      title: 'Craft compelling and shareable content to captivate your audience.',
      lines: [
        'Intuitive content creation tools for visually stunning posts.',
        'Enhance engagement with creative and impactful storytelling.',
        'Optimize content for different platforms and target audiences.'
      ],
    },
  ];
  
  const monitoringAnalyzingData = [
    {
      icon: <FaEye />,
      image: mn,

      iconTitle: 'Monitoring & Analyzing',
      title: 'Monitor your brand\'s social media presence and analyze performance.',
      lines: [
        'Real-time monitoring of brand mentions, tags, and comments.',
        'In-depth analytics to track key performance indicators.',
        'Understand sentiment, trends, and audience behavior.'
      ],
    },
  ];
  const calendarPlannerData = [
    {
      icon: <FaCalendarAlt />,
      image: cl,

      iconTitle: 'Calendar Planner',

      title: 'Strategically plan and organize your social media content calendar.',
      lines: [
        'Efficient scheduling of posts for optimal reach and engagement.',
        'Visualize and plan campaigns, events, and promotions.',
        'Coordinate content across platforms for a cohesive brand message.'
      ],
    },
  ];

  const postsManagementData = [
    {
      icon: <FaPaperPlane />,
      iconTitle: 'Posts Management',
      image: ps,

      title: 'Effortlessly manage and organize your social media posts.',
      lines: [
        'Review, edit, and organize scheduled and published posts.',
        'Ensure consistency in messaging and branding.',
        'Track the performance of individual posts for continuous improvement.'
      ],
    },
  ];
  const commentsEngagementData = [
    {
      icon: <FaComments />,
      iconTitle: 'Comments Engagement',
      image: cm,

      title: 'Engage with your audience through thoughtful and timely responses.',
      lines: [
        'Efficiently manage and respond to comments on your posts.',
        'Encourage positive interactions and address customer inquiries.',
        'Build a vibrant and engaged community around your brand.'
      ],
    },
  ];
  
  const reviewCard = [{
    icon:<FaUserCircle />,
    title: 'Strategic Content Planning',
  sub: 'Efficiently plan campaigns, events, and promotions for a cohesive social media presence.',
},
{
    icon:<FaPaperPlane />,
    title: 'Effortless Posts Management',
    sub: 'Streamline the management of scheduled and published posts for consistency and performance.',
  },
{
    icon:<FaComments />,
    title: 'Engage with Your Audience',
    sub: 'Build a vibrant community by efficiently managing and responding to comments on your posts.',
  },]

  
  return (
    <div className='pt-5  gap-[70px] flex flex-col items-center min-h-full w-full'>
    <div className='w-full flex justify-center bg-white sticky top-0 pt-5'>
        <div   className={` w-[78%]   flex  bg-white  pb-4 `}>    
            <div className='flex gap-2 items-center'>
                <div>
                <TiSocialInstagram className='text-[30px] text-blue-600' />
                </div>
                <div className='flex flex-col'>
                    <span className='semibold text-[13px]'>Elyzian</span>
                    <span className='bold text-sm'>Social Management</span>

                </div>
            </div>
        </div>
  </div>

  {/* 1st Section */}

  <div   className="w-full sm:w-[90%] lg:w-[85%] 2xl:w-[78%] h-max lg:h-[620px] sm:mt-3  flex flex-col lg:flex-row gap-6 lg:gap-3   p-[5%] bg-[#fafafa] sm:rounded-[50px]">       
     <div className='w-full lg:w-[50%] flex flex-col gap-5 justify-start h-full'>
        <div>     
        <span className='bold text-[28px] lg:text-[32px] xl:text-[38px] 2xl:text-[44px]   sm:leading-[45px] xl:leading-[55px] 2xl:leading-[65px]'>Craft. Monitor. Engage. Succeed.</span>    
</div>
       
        <span className='regular  text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] leading-[26px] lg:leading-[36px]  '>Seamlessly compose captivating content, monitor and analyze audience interactions, and strategically plan your social media calendar. With an intuitive planner, effortless post scheduling, and insightful comment tracking, you gain the tools to navigate the dynamic landscape of social platforms. 
        </span>
        
            
            <button onClick={() => navigate('/waitlist')} className="flex items-center gap-2 text-sm w-max  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
<span className="button-content medium">Get Started Free</span>
</button>
     </div>
     <div className=' xl:flex xl:justify-center w-full lg:w-[50%]'>
     <img className='xl:h-[470px] aspect-auto' src={fs} alt="" />
     </div>
  </div>

  {/* 2nd Section */}
        <Clients />

        {/* 3rd Section */}
        <div  className="w-[90%] lg:w-[85%] 2xl:w-[78%] flex flex-col gap-10 mt-24 items-center">       
<span className='bold text-center  text-[20px] sm:text-[24px] lg:text-[30px]'>Why does social management matter?</span>
<div className=' flex flex-wrap xl:flex-nowrap gap-4 justify-evenly w-full'>
 {reviewCard?.map((e) => (
    <div className="w-[380px] h-[400px] border rounded-[30px] shadow-md bg-[#fafafa] flex flex-col gap-5 p-6">
    <span className="text-2xl xl:text-3xl 2xl:text-5xl text-blue-700"> {e.icon}</span>
    <span className='bold text-[17px] xl:text-[20px]  '>{e.title}</span>    
        
         <span className='regular text-sm lg:text-base leading-[25px] lg:leading-[30px] break-words  '>{e.sub}</span>
    </div>
 ))}
   

</div>
</div>
  {/* 4th Section */}
  <PageSection bg  data={composeEngagingContentData} />

  <PageSection reverse  data={monitoringAnalyzingData} />
  {/* <Clients /> */}


  <PageSection   data={calendarPlannerData} />

  <PageSection bg  data={postsManagementData} />

  <PageSection reverse  data={commentsEngagementData} />

  <Branding />





  <Compliance />

  <Booking />

  <Footer />






</div>
  )
}

export default Social
